<template>
  <div class="bg-white rounded-t-3xl p-6 pb-8 max-h-[90vh] flex flex-col">
    <div class="w-12 h-1.5 bg-gray-300 rounded-full mx-auto mb-6" />

    <div class="flex items-center justify-between mb-6">
      <h2 class="text-xl font-semibold text-gray-900">
        Payment Method
      </h2>
      <button
        class="w-8 h-8 flex items-center justify-center rounded-full hover:bg-gray-100 transition-colors"
        @click="$emit('close')"
      >
        <i class="fas fa-times text-gray-500" />
      </button>
    </div>

    <div class="flex-grow overflow-y-auto pr-2 -mr-2">
      <div class="space-y-3 mb-6">
        <div
          v-for="method in paymentMethods"
          :key="method.id"
          :class="[
            'flex items-center justify-between p-4 border rounded-xl transition-colors',
            method.isDisabled
              ? 'opacity-50 bg-gray-50 border-gray-200 cursor-not-allowed'
              : selectedPayment === method.id
                ? 'border-[#0B63F6] bg-blue-50 cursor-pointer'
                : 'border-gray-200 hover:border-blue-300 cursor-pointer',
          ]"
          @click="selectPaymentMethod(method.id)"
        >
          <div class="flex items-center gap-3">
            <img
              :src="method.logo"
              class="w-12 h-8 object-contain rounded-lg"
              :alt="method.name"
              :class="
                method.isDisabled && method.id !== 'billplz' ? 'grayscale' : ''
              "
            >
            <div>
              <p class="font-medium text-gray-900">
                {{ method.name }}
              </p>
              <p class="text-sm text-gray-500">
                {{ method.details }}
              </p>
            </div>
          </div>

          <div
            v-if="!method.isDisabled"
            class="w-5 h-5 border-2 rounded-full flex items-center justify-center"
            :class="
              selectedPayment === method.id
                ? 'border-[#0B63F6] bg-[#0B63F6]'
                : 'border-gray-300'
            "
          >
            <i
              v-if="selectedPayment === method.id"
              class="fas fa-check text-white text-xs"
            />
          </div>
        </div>
      </div>

      <button
        class="w-full flex items-center justify-center gap-2 p-4 border-2 border-dashed border-gray-300 rounded-xl text-gray-400 cursor-not-allowed mb-6 opacity-70"
        disabled
      >
        <i class="fas fa-plus" />
        <span class="font-medium">Add Payment Method</span>
      </button>
    </div>
    <div class="pt-4 mt-auto">
      <button
        :disabled="!selectedPayment || processing"
        class="w-full bg-[#0B63F6] hover:bg-[#155EE0] text-white py-4 rounded-xl font-semibold text-lg shadow-lg transition-colors disabled:opacity-50"
        @click="confirmPayment"
      >
        Confirm Payment
      </button>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";

const paypalLogo = "/src/assets/paypal.png";
const mcLogo = "/src/assets/pay-mastercard.png";
const visaLogo = "/src/assets/pay-visa.png";
const billplzLogo = require("@/assets/billplz-logo.png");

const emit = defineEmits(["close", "paymentSuccess"]);

const paymentMethods = ref([
  {
    id: "paypal",
    name: "PayPal",
    details: "****@gmail.com",
    logo: paypalLogo,
    isDisabled: true,
  },
  {
    id: "mastercard",
    name: "Mastercard",
    details: "**** **** **** 1234",
    logo: mcLogo,
    isDisabled: true,
  },
  {
    id: "visa",
    name: "Visa",
    details: "**** **** **** 5678",
    logo: visaLogo,
    isDisabled: true,
  },
  {
    id: "billplz",
    name: "Billplz",
    details: "Pay with Online Banking / FPX",
    logo: billplzLogo,
    isDisabled: false,
  },
]);

const selectedPayment = ref("billplz");
const processing = ref(false);

const selectPaymentMethod = (methodId) => {
  const method = paymentMethods.value.find((m) => m.id === methodId);
  if (method && !method.isDisabled) {
    selectedPayment.value = methodId;
  }
};

const confirmPayment = () => {
  if (selectedPayment.value && !processing.value) {
    processing.value = true;
    setTimeout(() => {
      emit("paymentSuccess", selectedPayment.value);
      processing.value = false;
    }, 500);
  }
};
</script>

<style scoped>
/* Custom scrollbar for modal */
::-webkit-scrollbar {
  width: 4px;
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 2px;
}

::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 2px;
}

::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

/* Custom style for grayscale/dimming logos */
.grayscale {
  filter: grayscale(100%);
  opacity: 0.8;
}
</style>
